import { CheckEbInviteMeta, CheckEbInvitePayload } from 'types/store/CheckEbInvite';
import { createAsyncReducer } from 'utils/Redux';

import { checkEbInviteActions } from '../actions';

export default createAsyncReducer<CheckEbInviteMeta, CheckEbInvitePayload>(checkEbInviteActions);
